import styled from '@emotion/styled';
import { Pagination as PaginationAntd } from 'antd';
import { PaginationProps } from 'antd/lib/pagination';
import React from 'react';
import { theme } from '../../configs/styled';

export interface IPaginationProps extends PaginationProps {}

const PaginationBase = styled(PaginationAntd)`
  outline: none;
  .ant-pagination-item {
    border-radius: 1px;
    color: gray !important;
    width: ${theme.spacing.xxl};
    height: ${theme.spacing.xxl};
    border: none;
    z-index: 100;
    a {
      color: grey;
    }
    &:hover {
      background-color: ${theme.palettes.primaryHover};
    }
    &:hover > a {
      color: ${theme.palettes.primary};
    }
  }
  .ant-pagination-item-active {
    background-color: ${theme.palettes.primary};
    &:hover {
      background-color: ${theme.palettes.primary};
    }
    & > a {
      color: ${theme.palettes.white} !important;
    }
  }
  .ant-pagination-item-link {
    border: none;
    color: gray;
  }
  color: gray;
  font-size: 13px;
`;

const Pagination: React.FC<IPaginationProps> = ({ ...props }) => {
  return <PaginationBase {...props} />;
};

export default React.memo(Pagination);
